module.exports = __webpack_public_path__ + "static/media/lokmanyamob-4.6ec781ab.png";